import * as React from 'react'
import styled from '@emotion/styled'
import { fonts } from '../styles/variables'
import Ripples from 'react-ripples'
import { FormattedMessage } from 'react-intl';
import { navigate} from "@reach/router";
import { createPaymentIntent } from '../functions/stripeFunctions'
import {
  getNewOrderID,
  getQuantity,
  getRequestData,
  readBulkedInventory,
  setBulkedInventory
} from '../functions/stockFunctions'
import { sendAdminOrderSuccess, sendCusOrderSuccess } from '../functions/sesFunctions'

const LilaCrypto = styled.div`
width:100%;


`

const StyledSpinner = styled.div`
width:100%;
height:100%;
margin-bottom:2rem;
margin-top:2rem;
margin-left:10%;
display:flex;
justify-content:flex-start;
align-items:center;

`

const LilaSpinner =styled.div`
.cls-1{fill:var(--hase);}

width:64px;




.rotate {
  animation: rotation 1s infinite linear;


}

@keyframes rotation {
  from {
    transform: rotate(0deg) scale(0.67) ;
  }
  to {
    transform: rotate(359deg) scale(0.67);
  }
}
`

const Wrapper = styled.div`
.StripeElement{
padding-right:0px !important;
padding-left:10px !important;

font-family:${fonts.bcHairLine};


}

.error{
color:var(--txt);
font-family:${fonts.bcHairLine};
}

`


const LilaTitle = styled.div`
font-family:${fonts.bcHairLine};
margin-top:0.7rem;
margin-bottom:1.1rem;
display:flex;
align-items:center;

`


const LilaTitle_2 = styled.div`
font-family:${fonts.bcHairLine};
margin-top:0.7rem;

display:flex;
align-items:center;

`

const LilaPay = styled(Ripples)`
font-family:${fonts.bcExtraLight};
margin-top:1.2rem;
margin-bottom:1.2rem;
border:none;
cursor:pointer;
width:250px;
height:35px;
display:flex;
justify-content:center;
align-items:center;
background: var(--haase);
color:white;
  border-radius:18px;
    opacity:1;
transition: opacity .4s ease;


:hover{
opacity:1;
text-decoration:underline;
background: var(--haase);


}

`

const LilaSecurity = styled.div`
display:flex;
height:80px;
align-items:center;
font-family:${fonts.bcHairLine};



`
const LilaSecuredBy = styled.div`
margin-right:1rem;

`

const LilaOpenNode = styled.div`
#_on_txt{
opacity:.3;
}
svg{

}
`



class CryptoGate extends React.Component {
  constructor(props: any) {
    super(props)
    this.state = {
      waitToRedirect:false,
      success:false,
      failed:false
    }
    this.redirectToOpenNode=this.redirectToOpenNode.bind(this)
    this.createCryptoData=this.createCryptoData.bind(this)
  }

  createCryptoData(data){

    let cryptoData = {
      descr:'Pay your products from LILA HASE.',
      total:data.total,
      fullName:data._lila_cus_name1+' '+data._lila_cus_name2,
      mail:data._lila_cus_mail,
      order_id:'285-7997'

    }
    return cryptoData
  }

  showLoadingError(){
    //todo:
  }

  redirectToOpenNode(){
    this.setState({showSpinner:true})

    const opennode = require('opennode');
    this.setState({
      waitToRedirect:true
    })
    const cryptoData = this.createCryptoData(this.props.data)
    let cData = this.props.data
    let extra = {
      payment_method_types:['card'],
      confirmation:false,
      capture_method:'automatic'
    }
    let cryptoPayment =  createPaymentIntent(cData, extra);

    cryptoPayment.then(function(pm) {
let pay =pm.paymentIntent
if(pay!=undefined) {

  opennode.setCredentials('3f081c2c-08a5-48d6-8476-1e20a3439f53');

  const charge = {
    description: cryptoData.descr,
    amount: cData.total-cData.discount+cData.shipping, // required
    currency: 'EUR',
    order_id: pm.paymentIntent.id, //todo: add stripe paymentInent id
    customer_name: cryptoData.fullName,
    customer_email: cryptoData.mail,
    notif_email: 'info@lilahase.com',
    callback_url: "https://www.getpostman.com/oauth2/callback",
    success_url: 'https://lilahase.com/order-success',
    auto_settle: false
  };

  opennode.createCharge(charge)
    .then(charge => {
      console.log(charge);
      this.setState({
        waitToRedirect: false,
        success: true

      })
      let uri = 'https://checkout.opennode.co/' + charge.id

      readBulkedInventory(cData.cartItems)
        .then(dynamoData => {
          // console.log(dynamoData)
          const requestData = getRequestData( dynamoData.data, getQuantity(cData.cartItems))
          setBulkedInventory(requestData)
          //todo: send error email to info@, add hook if to refill inventory if invoice is not fullfilled

        })

      const orderID = getNewOrderID()
      sendCusOrderSuccess(cData, orderID)
      sendAdminOrderSuccess(cData, orderID)
      //todo:
      //      backend: error/bounce handling
      //      frontend: show notifcation

      navigate(uri)
    }).bind(this)
    .catch(error => {
      console.log('failed')
      console.error(`${error.status} | ${error.message}`);
    });
}
else {

  this.setState({showSpinner:false})
}
  }.bind(this))

  }

  componentDidMount() {

  }

  render() {
    return(


        <LilaCrypto id={'component'}>
          <StyledSpinner style={{display:(this.state.showSpinner) ? 'flex':'none'}}>
            <LilaSpinner>
              <svg className="rotate" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 241.36 179.42">
                <defs>
                </defs>
                <path className="cls-1"
                      d="M612.62,378.23,762.71,495,536.84,509.45l75.78-131.22m-1-5.15-81,140.22L772,497.82,611.62,373.08Z"
                      transform="translate(-530.64 -373.08)"/>
                <path className="cls-1"
                      d="M612.62,377l41.91,11.84,55.64,15.73,57.17,92.32-75.55,52L554.7,516.38,535,510.93l25.64-82.21,52-51.77m-1-3.87-54,53.8-27,86.42,23.21,6.42L692.49,552.5,772,497.82l-59.6-96.25-56.93-16.09-43.85-12.4Z"
                      transform="translate(-530.64 -373.08)"/>
              </svg>
            </LilaSpinner>
          </StyledSpinner >
          <div style={{display:(this.state.showSpinner) ? 'none':'block'}}>
<LilaPay onClick={this.redirectToOpenNode}><FormattedMessage id={'pm_x'}/></LilaPay>

          <LilaSecurity> <LilaSecuredBy>secured by </LilaSecuredBy> <LilaOpenNode><svg width="144" height="28" xmlns="http://www.w3.org/2000/svg">
  <g fill="none" fill-rule="evenodd">
    <path id={'_on_txt'} d="M43.945 14.034c0 3.795-2.871 6.66-6.714 6.66-3.845 0-6.7-2.865-6.7-6.66 0-3.792 2.855-6.658 6.7-6.658 3.843 0 6.714 2.866 6.714 6.658zm-11.185 0c0 2.677 1.922 4.601 4.471 4.601 2.537 0 4.47-1.924 4.47-4.6 0-2.678-1.933-4.588-4.47-4.588-2.55 0-4.47 1.91-4.47 4.587zm26.165 0c0 3.863-2.788 6.66-6.34 6.66-2.002 0-3.482-.78-4.47-1.978v7.09h-2.176V7.644h2.175v1.708c.99-1.196 2.47-1.976 4.471-1.976 3.552 0 6.34 2.798 6.34 6.658zm-10.943 0c0 2.625 1.789 4.601 4.351 4.601 2.628 0 4.351-2.057 4.351-4.6 0-2.542-1.762-4.588-4.35-4.588-2.563 0-4.352 1.978-4.352 4.587zm24.973-.04c0 .283-.026.58-.039.82h-9.97c.307 2.651 2.135 3.957 4.31 3.957 1.483 0 2.83-.579 3.913-1.52l1.16 1.507c-1.575 1.479-3.336 1.936-5.205 1.936-3.765 0-6.434-2.677-6.434-6.66 0-3.928 2.656-6.658 6.301-6.658 3.456 0 5.938 2.704 5.964 6.619zm-9.983-.954h7.755c-.267-2.261-1.72-3.714-3.777-3.714-2.24 0-3.643 1.534-3.978 3.714zm23.635-.553v7.938h-2.19v-7.226c0-2.352-1.28-3.74-3.482-3.74-2.043 0-3.752 1.414-3.752 3.795v7.17h-2.175V7.645h2.162v1.669c1.041-1.44 2.682-1.937 4.152-1.937 3.123 0 5.285 2.044 5.285 5.111zm13.858 0v7.938h-2.19v-7.226c0-2.352-1.281-3.74-3.483-3.74-2.043 0-3.751 1.414-3.751 3.795v7.17h-2.176V7.645h2.163v1.669c1.04-1.44 2.682-1.937 4.151-1.937 3.123 0 5.286 2.044 5.286 5.111zm15.173 1.547c0 3.795-2.871 6.66-6.714 6.66-3.845 0-6.7-2.865-6.7-6.66 0-3.792 2.855-6.658 6.7-6.658 3.843 0 6.714 2.866 6.714 6.658zm-11.185 0c0 2.677 1.922 4.601 4.47 4.601 2.537 0 4.472-1.924 4.472-4.6 0-2.678-1.935-4.588-4.471-4.588-2.55 0-4.47 1.91-4.47 4.587zm23.52-4.668V2.258l2.189.005v18.162h-2.189v-1.709c-1 1.198-2.482 1.978-4.47 1.978-3.565 0-6.34-2.797-6.34-6.66 0-3.86 2.775-6.658 6.34-6.658 1.988 0 3.47.78 4.47 1.99zm-8.58 4.668c0 2.544 1.76 4.601 4.364 4.601 2.562 0 4.351-1.976 4.351-4.6 0-2.61-1.789-4.588-4.351-4.588-2.643 0-4.365 2.046-4.365 4.587zm24.558-.04c0 .283-.026.58-.039.82h-9.97c.307 2.651 2.135 3.957 4.31 3.957 1.483 0 2.83-.579 3.913-1.52l1.16 1.507c-1.575 1.479-3.336 1.936-5.205 1.936-3.764 0-6.433-2.677-6.433-6.66 0-3.928 2.656-6.658 6.3-6.658 3.456 0 5.938 2.704 5.964 6.619zm-9.982-.954h7.755c-.268-2.261-1.722-3.714-3.778-3.714-2.24 0-3.643 1.534-3.977 3.714z" fill="var(--txt)"/>
    <path fill="#655AE6" d="M24.002 20.954V6.984L12 0v13.969z"/>
    <path fill="#5A50CE" d="M24.002 6.985L12 0v13.969z"/>
    <path fill="#655AE6" d="M24.002 20.953l-12-6.984 12-6.984z"/>
    <path fill="#4896F0" d="M24.002 20.954l-12-6.985L0 20.953l12.001 6.985z"/>
    <path fill="#4896F0" d="M12.001 27.937V13.97l12.001 6.984z"/>
    <path fill="#4086D7" d="M0 20.953l12.001-6.984v13.968z"/>
    <path fill="#F5D980" d="M12 0L0 6.984v13.969l12.001-6.984z"/>
    <path fill="#F2D268" d="M0 6.984v13.969l12.001-6.984z"/>
    <path fill="#FADA70" d="M12 0L0 6.984l12.001 6.985z"/>
  </g>
          </svg></LilaOpenNode></LilaSecurity></div>
    </LilaCrypto>



    )
  }
}


export default CryptoGate


//<P><Zoom delay={4200} right cascade>CBD BLÜTEN</Zoom></P>
